module.exports = __webpack_public_path__ + "static/media/1.40e6eb90.jpg";